import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useTable, useSortBy, useFlexLayout, } from 'react-table';
import { ReactTableStyle } from './Style';
function ReactTableFlexLayout({ data, columns, onMouseDown = () => null, style = {}, }) {
    const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } = useTable({
        columns,
        data,
    }, useSortBy, useFlexLayout);
    return (_jsxs("table", { ...getTableProps(), css: ReactTableStyle, style: { height: '100%', ...style }, children: [_jsx("thead", { children: headerGroups.map((headerGroup) => {
                    const { key: headerGroupKey, ...restHeaderGroupProps } = headerGroup.getHeaderGroupProps();
                    return (_jsx("tr", { ...restHeaderGroupProps, children: headerGroup.headers.map((column) => {
                            const { key: headerKey, ...restHeaderProps } = column.getHeaderProps(column?.getSortByToggleProps());
                            return (_jsxs("th", { ...restHeaderProps, children: [column.render('Header'), _jsx("span", { children: column.isSorted
                                            ? column.isSortedDesc
                                                ? ' ▼'
                                                : ' ▲'
                                            : '' })] }, headerKey));
                        }) }, headerGroupKey));
                }) }), _jsx("tbody", { ...getTableBodyProps(), style: { display: 'block', height: '100%', overflowY: 'auto' }, children: rows.map((row) => {
                    prepareRow(row);
                    const { key: rowKey, ...resetRowProps } = row.getRowProps();
                    return (_jsx("tr", { ...resetRowProps, onMouseDown: onMouseDown, children: row.cells.map((cell) => {
                            const { key: cellKey, style: cellStyle, ...resetCellProps } = cell.getCellProps();
                            return (_jsx("td", { ...resetCellProps, style: { ...cellStyle, padding: '0px' }, children: cell.render('Cell') }, cellKey));
                        }) }, rowKey));
                }) })] }));
}
export default ReactTableFlexLayout;
